import React from 'react';
import PropTypes from 'prop-types';
import {ButtonGroup, Modal} from '@/components/atoms';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';
import {getActivityReviewActionConfig} from '@/containers/Activity/ActivityReview/constants/activityReviewActionConfig';

const ActivityReviewActionButtons = ({reviewActions, activityKind}) => {
  const config = getActivityReviewActionConfig(activityKind);

  if (!config) {
    return null;
  }

  const {
    publishToggle,
    isDuplicateEnabled,
    isDownloadEnabled,
    showUnpublishModal,
    showPublishModal,
    handlePublishToggleClick,
    handleCloseUnpublishModal,
    handleClosePublishModal,
    handleConfirmUnpublish,
    handleConfirmPublish,
    handleDuplicate,
    handleDownload
  } = reviewActions;

  const buttonItems = [
    {
      icon: publishToggle.icon,
      label: publishToggle.label,
      onClick: handlePublishToggleClick,
      disabled: !publishToggle.enabled
    },
    {
      icon: 'content_copy',
      label: 'Duplicate',
      onClick: handleDuplicate,
      disabled: !isDuplicateEnabled
    },
    {
      icon: 'download',
      label: 'Download',
      onClick: handleDownload,
      disabled: !isDownloadEnabled
    }
  ];

  return (
    <>
      <ButtonGroup
        uiSchema={{items: buttonItems}}
        isDark
        id='activity-review-action-buttons'
        data-testid='activity-review-action-buttons'
        data-kind={activityKind}
      />

      {showUnpublishModal && (
        <Modal
          type={MODAL_TYPE.FLUID}
          showModal={showUnpublishModal}
          onCloseModal={handleCloseUnpublishModal}
          title={config.unpublishModalTitle}
          text={config.unpublishModalText}
          showPrimaryButton={true}
          primaryButtonText='Continue'
          onClickPrimaryButton={handleConfirmUnpublish}
          showSecondaryButton={true}
          secondaryButtonText='Cancel'
          onClickSecondaryButton={handleCloseUnpublishModal}
          footerProps={{size: 'medium', type: 'primary'}}
          isDark={true}
        />
      )}

      {showPublishModal && (
        <Modal
          type={MODAL_TYPE.FLUID}
          showModal={showPublishModal}
          onCloseModal={handleClosePublishModal}
          title={config.publishModalTitle}
          text={config.publishModalText}
          showPrimaryButton={true}
          primaryButtonText='Continue'
          onClickPrimaryButton={handleConfirmPublish}
          showSecondaryButton={true}
          secondaryButtonText='Cancel'
          onClickSecondaryButton={handleClosePublishModal}
          footerProps={{size: 'medium', type: 'primary'}}
          isDark={true}
        />
      )}
    </>
  );
};

ActivityReviewActionButtons.propTypes = {
  activityKind: PropTypes.oneOf([
    'survey',
    'video',
    'freeKick',
    'wheelOfFortune',
    'backgammon'
  ]).isRequired,
  reviewActions: PropTypes.shape({
    publishToggle: PropTypes.shape({
      action: PropTypes.string,
      label: PropTypes.string,
      icon: PropTypes.string,
      enabled: PropTypes.bool
    }),
    isDuplicateEnabled: PropTypes.bool,
    isDownloadEnabled: PropTypes.bool,
    showUnpublishModal: PropTypes.bool,
    showPublishModal: PropTypes.bool,
    handlePublishToggleClick: PropTypes.func,
    handleCloseUnpublishModal: PropTypes.func,
    handleClosePublishModal: PropTypes.func,
    handleConfirmUnpublish: PropTypes.func,
    handleConfirmPublish: PropTypes.func,
    handleDuplicate: PropTypes.func,
    handleDownload: PropTypes.func
  }).isRequired
};

export default ActivityReviewActionButtons;
